export const tools = [
  {
    id: 'angular-to-linear-freq',
    name: "Angular to Linear Frequency Converter",
    category: "Conversions",
    component: 'AngularToLinearFreqConverter',
    description: 'Convert between angular frequency (ω in rad/s) and linear frequency (f in Hz).'
  },
  {
    id: 'ohms-law',
    name: "Ohm's Law Calculator",
    category: "DC",
    component: 'OhmsLaw'
  },
  {
    id: 'reactance-calculator',
    name: 'Reactance Calculator',
    description: 'Calculates capacitive or inductive reactance based on frequency and component values.',
    category: 'AC',
    component: 'ReactanceCalculator',
    image: '/images/Placeholder.png',
  },
  {
    id: 'spherical-cartesian',
    name: 'Spherical-Cartesian Converter',
    category: 'Conversions',
    component: 'SphericalCartesianConverter',
    description: 'Convert between 3D spherical (polar) and Cartesian coordinates. For 2D, set unused axes to zero.'
  },
  {
    id: 'voltage-divider',
    name: "Voltage Divider Calculator",
    category: "DC",
    component: 'VoltageDivider'
  },
  {
    id: 'current-divider',
    name: "Current Divider Calculator",
    category: "DC",
    component: 'CurrentDivider'
  },
  {
    id: 'db-to-linear',
    name: "dB to Linear Scale Calculator",
    category: "Conversions",
    component: 'DbToLinear',
    description: 'Convert between decibels and linear scale for either power or voltage ratios.'
  },
  {
    id: 'wavelength-to-frequency',
    name: "Wavelength to Frequency Converter",
    category: "Conversions",
    component: 'WavelengthToFrequency',
    description: 'Convert between wavelength and frequency.'
  },
  {
    id: 'rl-ml-reflection-vswr',
    name: "VSWR-RL-ML-Reflection Coefficient Converter",
    category: "Conversions",
    component: 'RLMLReflectionVSWR',
    description: 'Convert between VSWR, Return Loss, Mismatch Loss, and Reflection Coefficient (Γ). Enter one quantity and calculate the rest.'
  },
  {
    id: 'FSPL',
    name: "Free Space Path Loss Calculator",
    category: "RF",
    component: 'FreeSpacePathLoss',
    description: 'Calcualte Free Space Path Loss.'
  },
  {
    id: 'l-section-matching',
    name: 'L-Section Impedance Matching',
    description: 'Calculates L-section matching network values for transforming impedances.',
    category: 'RF',
    component: 'LSectionImpedanceMatch',
    image: '/images/Placeholder.png',
  },
  {
    id: 'resonant-frequency',
    name: 'Resonant Frequency Calculator',
    description: 'Calculates the resonant frequency of an LC circuit.',
    category: 'AC',
    component: 'ResonantFrequency',
    image: '/images/Placeholder.png',
  },
  {
    id: 'rc-rl-time-constant',
    name: 'RC and RL Time Constant Calculator',
    description: 'Calculates the time constant for RC circuits based on resistance and capacitance.',
    category: 'AC',
    component: 'RCRLTimeConstant',
    image: '/images/Placeholder.png',
  },
  {
    id: 'filter-design-calculator',
    name: 'Filter Design Calculator',
    description: 'Calculates the inductance and capacitance values for a variety of filter types and topologies.',
    category: 'AC',
    component: 'FilterDesignCalculator',
    image: '/images/Placeholder.png',
  },
  {
    id: 'dc-power',
    name: 'DC Power Calculator',
    description: 'Enter any two of voltage, current, resistance, or power to calculate the others in a DC circuit.',
    category: 'DC',
    component: 'DcPowerCalculator',
    image: '/images/Placeholder.png',
  },
  {
    id: 'ac-power',
    name: 'AC Power Calculator',
    description: 'AC Power Calculator',
    category: 'AC',
    component: 'AcPowerCalculator',
    image: '/images/Placeholder.png',
  },
  {
    id: 'temperature-converter',
    name: 'Temperature Converter',
    description: 'Convert between degrees Celsius, degrees Fahrenheit, and Kelvin.',
    category: 'Conversions',
    component: 'TemperatureConverter'
  },
  {
    id: 'dbm-to-linear',
    name: 'dBm ↔ Linear Power Converter',
    description: 'Convert between dBm and Watts/mW.',
    category: 'RF',
    component: 'DbmToLinear'
  },
  {
    id: 'quarter-wave-transformer',
    name: 'Quarter-Wave Transformer',
    description: 'Calculate matching impedance for a quarter-wave transformer.',
    category: 'RF',
    component: 'QuarterWaveTransformer'
  },
  {
    id: 'attenuator-design',
    name: 'Attenuator Design Calculator',
    description: 'Calculate resistor values for fixed attenuator design.',
    category: 'RF',
    component: 'AttenuatorDesign'
  },
  {
    id: 'number-system-converter',
    name: 'Number System Converter',
    description: "Convert between binary (unsigned, sign-magnitude, one's complement, two's complement) and decimal, hex, or octal.",
    category: 'Conversions',
    component: 'NumberSystemConverter'
  },
  {
    id: 'floating-point-converter',
    name: 'Floating Point Converter',
    description: "Convert between IEEE 754 and half-precision floating point binary representations.",
    category: 'Conversions',
    component: 'FloatingPointConverter'
  }
];
